<template>
  <div id="hres6ju">
    <hrms-search-box-table v-show="indexDisp"
            :data="index"
            :nowLang="dash.nowLang"
            :columns="columns[dash.nowLang].index"
            :receivedStore="receivedHres6juIndex"
            searchBoxAlias="approve"
            :detailEvent="detailEvent"
            :approveEvent="approveEvent"
            :approveRowBool="true" />

    <detail v-show="detailDisp"
            :labels="labels[dash.nowLang]"
            :labelsButton="dash.button[dash.nowLang]"
            :detail="detail.tab1"
            :popupTab1="popupTab1"
            :toggle="toggle"
            :nowLang="dash.nowLang"
            :arrCodtparg="dropdowns.codtparg"
            :maxRowspanPopupTable1="maxRowspan.popupDetail"
            :tab1PopupTable1="columns[dash.nowLang].tab1PopupTable1"
            :tab1PopupTable2="columns[dash.nowLang].tab1PopupTable2"
            :receivedHres6juDetailPopup="receivedHres6juDetailPopup" />

    <div class="form-group-button" v-show="false">
      <button class="btn bg-blue" data-toggle="modal" ref="approve" data-target="#hres6ju-popup-approve" @click="callPopupApprove()"><i class="fa fa-list-alt"></i> {{ dash.button[dash.nowLang].approve }}</button>
    </div>

    <!-- <div class="form-group-button" v-show="indexDisp">
      <button class="btn bg-blue" data-toggle="modal" data-target="#hres6ju-popup-training"><i class="fa fa-list-alt"></i> {{ dash.button[dash.nowLang].training }}</button>
    </div> -->

    <popup-approve :labels="labels[dash.nowLang]"
            :nowLang="dash.nowLang"
            :labelsButton="dash.button[dash.nowLang]"
            :arrCodcours="dropdowns.codcours"
            :arrNumclseq="dropdowns.numclseq"
            :arrCodplan="dropdowns.codplan"
            :postHres6juSendApprove="postHres6juSendApprove"
            :receivedHres6juCourseDetail="receivedHres6juCourseDetail"
            :indexSelected="indexSelected"
            :courseDetail="courseDetail"
            :detailSubmit="detailSubmit"
            :codappr="codempid"
            :descCodappr="dash.currentUser.username[dash.nowLang]"
            :isPopupFirstLoad="isPopupFirstLoad"
            :setPopupFirstLoad="setPopupFirstLoad"
            :receivedHres6juNumclseq="receivedHres6juNumclseq" />

    <popup-training :labels="labels[dash.nowLang]"
            :nowLang="dash.nowLang"
            :labelsButton="dash.button[dash.nowLang]"
            :arrCodplan="dropdowns.codplan"
            :arrCodcours="dropdowns.codcours"
            :training="training"
            :codempid="codempid"
            :popupTrainingTable="columns[dash.nowLang].popupTrainingTable"
            :receivedHres6juTraining="receivedHres6juTraining" />

  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hres6ju/mutation-types'
import detail from 'components/hres6ju/detail'
import popupApprove from 'components/hres6ju/popupApprove'
import popupTraining from 'components/hres6ju/popupTraining'
import moment from 'moment'
import swal from 'sweetalert'

export default {
  name: 'hres6ju',
  data () {
    return {
      dash: this.$parent.$parent.$parent,
      dtereq: moment().format('DD/MM/YYYY'),
      btn_approve: 'Approve',
      isPopupFirstLoad: true
    }
  },
  created () {
    this.receivedHres6juColumnsLabels()
    this.receivedHres6juIndex()
    this.receivedHres6juDropdowns()
  },
  computed: {
    codempid () {
      let currentUser = this.dash.currentUser
      return currentUser.p_codempid
    },
    // descCodempid () {
    //   let currentUser = this.dash.currentUser
    //   return currentUser.p_codempid
    // },
    ...mapGetters({
      indexDisp: types.GET_HRES6JU_INDEX_DISP,
      detailDisp: types.GET_HRES6JU_DETAIL_DISP,
      maxRowspan: types.GET_HRES6JU_MAX_ROWSPAN,
      columns: types.GET_HRES6JU_COLUMNS,
      labels: types.GET_HRES6JU_LABELS,
      index: types.GET_HRES6JU_INDEX,
      indexSelected: types.GET_HRES6JU_INDEX_SELECTED,
      detail: types.GET_HRES6JU_DETAIL,
      dropdowns: types.GET_HRES6JU_DROPDOWNS,
      training: types.GET_HRES6JU_TRAINING,
      popupTab1: types.GET_HRES6JU_DETAIL_POPUP,
      courseDetail: types.GET_HRES6JU_COURSE_DETAIL,
      detailSubmit: types.GET_HRES6JU_DETAIL_SUBMIT
    })
  },
  methods: {
    pageDetail (event) {
      let detailParams = this.indexSelected
      this.receivedHres6juDetail(detailParams)
      this.toggle('detail')
    },
    detailEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail(param)
    },
    approveEvent (dataRows) {
      let dataRowsFiltered = dataRows.filter(function (dataRow) {
        return dataRow.flgStaappr !== 'undefined' && dataRow.flgStaappr !== 'P' && dataRow.flgStaappr.trim() !== ''
      })
      if (dataRowsFiltered.length > 0) {
        this.setIndexSelected(dataRowsFiltered[0])
        this.receivedHres6juDetailSubmit(this.indexSelected)
        this.$refs.approve.click()
      } else {
        swal({
          title: 'ยืนยันการทำรายการ',
          text: 'รายการยังไม่ถูกเลือก'
        })
      }
    },
    setPopupFirstLoad (bool) {
      this.isPopupFirstLoad = bool
    },
    callPopupApprove () {
      this.isPopupFirstLoad = true
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRES6JU_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRES6JU_PAGE,
      receivedHres6juColumnsLabels: types.RECEIVED_HRES6JU_COLUMNS_LABELS,
      receivedHres6juIndex: types.RECEIVED_HRES6JU_INDEX,
      receivedHres6juDetail: types.RECEIVED_HRES6JU_DETAIL,
      receivedHres6juDropdowns: types.RECEIVED_HRES6JU_DROPDOWNS,
      postHres6juSendApprove: types.POST_HRES6JU_SEND_APPROVE,
      receivedHres6juTraining: types.RECEIVED_HRES6JU_TRAINING,
      receivedHres6juDetailPopup: types.RECEIVED_HRES6JU_DETAIL_POPUP,
      receivedHres6juDetailSubmit: types.RECEIVED_HRES6JU_DETAIL_SUBMIT,
      receivedHres6juCourseDetail: types.RECEIVED_HRES6JU_COURSE_DETAIL,
      receivedHres6juNumclseq: types.RECEIVED_HRES6JU_NUMCLSEQ
    })
  },
  components: {
    detail,
    popupApprove,
    popupTraining
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?0280d114